
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LanguageIcon from '@mui/icons-material/Language';
import TtkList from './TtkList';
const PanditTTK = ({ data }) => {
    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area of Services :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Samagri :</b>&nbsp;<TtkList data={data?.samagri} /></p>
                        </div>


                    </div>
                    <div className='row mb-1'>
                       
                        
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Price of Wedding Services :</b>&nbsp;<span>&#8377;{data?.WeddingPrice}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Pricing for Kundli Matching Per Person :</b>&nbsp;<span>&#8377;{data?.kundaliMatchPrice}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Languages You Prefer Rituals In? :</b>&nbsp;<TtkList data={data?.language} /></p>
                        </div>
                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Pooja/Ceremonies You Offer? :</b>&nbsp;<TtkList data={data?.servicePandit} /></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PanditTTK